/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function SeasonAggregationTabController(
    this: JS5Object,
    $timeout: JS5Function,
    ContentEditService: JS5Object,
) {

    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    let getData = () => {
        return ContentEditService.getSeasonVolumeEditData().then(() => {
            this.seasonVolume = ContentEditService.seasonVolumeObject;
        });
    };


    //===================//
    // Template Response //
    //===================//

    this.onExternalIdChange = () => {
        if (_.get(this.seasonVolume, 'externalId.length') == 0)
            this.seasonVolume.externalId = null;
    };

    this.clearExternalId = () => {
        this.seasonVolume.externalId = null;
        this.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator.show = true;

        getData().then(() => {
            $timeout(() => {
                // if the above promises resolve too quickly,
                // a $timeout() is required to shut the
                // pacifier off
                this.loadingIndicator.show = false;
            });
        });
    };

    this.$onDestroy = function () {
    };

    this.$postLink = function () {
        $timeout(() => {
            ContentEditService.editorForm = this.editorForm;
        });
    };


    //=========//
    // Toolbar //
    //=========//
    let isDirty = () => {
        let isDirty = _.get(this, 'editorForm.$dirty');
        return this.seasonVolume && isDirty;
    };

    this.toolbarButtons = [
        // Save
        {
            label: 'Save',
            enabled: () => isDirty(),
            onClick: () => {
                this.loadingIndicator.show = true;
                ContentEditService.saveSeasonVolume().then(() => {
                    this.seasonVolume = ContentEditService.seasonVolumeObject;
                    this.loadingIndicator.show = false;
                    this.editorForm.$setPristine();
                });
            },
        },

        // Revert
        {
            label: 'Revert',
            enabled: () => isDirty(),
            onClick: () => {
                ContentEditService.revertSeasonVolume();
                this.seasonVolume = ContentEditService.seasonVolumeObject;
                this.editorForm.$setPristine();
            },
        },

        // Close
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => ContentEditService.closeSeasonVolumeEditor(),
        },
    ];
}


angular
    .module('prism-ui.content')
    .component('seasonAggregationTab', {
        templateUrl: 'meta/content/editor/components/view/seasonvolume/editor/components/view/aggregation/aggregation-tab-template.html',
        controller: SeasonAggregationTabController,
        bindings: {
        }
    });
